import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "store";
import Header from "components/header";
import Footer from "components/footer";
import "bootstrap";
import App from "containers/App";
import { BrowserRouter } from "react-router-dom";
import Spinner from "components/common/spinner";
import { ToastContainer } from "react-toastify";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Spinner />
    <ToastContainer stacked />
    <BrowserRouter>
      <Header />
      <div className="flex-grow-1">
        <App />
      </div>
      <Footer />
    </BrowserRouter>
  </Provider>,
);
